<script>
export default 
{
    name: 'block-button',

    props:
    {
        big: Boolean,
    },

    methods:
    {
        clickHandler()
        {
            this.$emit('click')
        }
    }
}
</script>

<template>
<button class="btn btn-block block-button" :class="{'big': big }" @click.prevent.stop="clickHandler">
    <slot></slot>
</button>
</template>

<style lang="scss">
button.block-button {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: .7em 0;
    background-color: white;
    color: var(--color);
    border: 1px solid var(--color);

    &.big {
        padding: 1.4em 0;
    }

    span {
        font-family: 'ProximaNova';
    }

    &:focus {
        outline: none;
        box-shadow: none;
    }

    &:hover, &.selected {
        color: white !important;
        background-color: var(--color);
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/BlockButton.vue